import { Container, Grid, Link, Stack, Text } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";

export const DirectDebitError = ({ state }) => {
  const { toAccount, errorType } = state;
  const { cardName, cardEndsWith } = toAccount.data;
  const renderContent = () => {
    switch (errorType) {
      case "ACCOUNT_OVERDUE_BAL":
      case "ACCOUNT_OVERDUE_MMP":
      case "MISSED_PAYMENT": {
        return (
          <Stack gap="8">
            <SvgInline name="direct-debit-payment-cancel" size="92" />
            <Text textStyle="heading5" textStyle-sm="heading4">
              Sorry, we're unable to set up your direct debit request
            </Text>
            <Text>
              We've noticed that your account is overdue. Please make a one time
              payment to get it up to date before setting up a direct debit
              request.
            </Text>
            <Link
              appearance="primary-button"
              href="/ways-to-pay"
              newTab={false}
            >
              One time payment
            </Link>
          </Stack>
        );
      }

      case "DDR_ACCOUNT_STATUS": {
        return (
          <Stack gap="8">
            <SvgInline name="direct-debit-payment-cancel" size="92" />
            <Text textStyle="heading5" textStyle-sm="heading4">
              Sorry, we're unable to set up your direct debit request
            </Text>
            <Text>
              The status of your account means that we are unable to set up a
              direct debit request. Please contact Latitude if you require more
              information.
            </Text>
            <Link appearance="primary-button" href="/contact" newTab={false}>
              Contact Latitude
            </Link>
          </Stack>
        );
      }

      case "DDR_LFS_JOINT_ACCOUNT": {
        return (
          <Stack gap="8">
            <SvgInline name="direct-debit-payment-cancel" size="92" />
            <Text textStyle="heading5" textStyle-sm="heading4">
              Sorry, we're unable to set up your direct debit request
            </Text>
            <Text>
              You are attempting to set up a direct debit for your joint{" "}
              {cardName} account. Please complete the alternative direct debit
              request form for joint account holders instead.
            </Text>
            <Link
              appearance="primary-button"
              href="https://latitudefs.zendesk.com/hc/en-au/requests/new?ticket_form_id=360000137778"
              newTab
            >
              Direct debit request form
            </Link>
          </Stack>
        );
      }

      default: {
        return (
          <Stack gap="8">
            <SvgInline name="error-dog" width="236" />
            <Text textStyle="heading5" textStyle-sm="heading4">
              Oops, something went wrong
            </Text>
            <Text>
              We've encountered an unexpected problem and are experiencing
              difficulties in processing your request. Please try again later or
              contact Latitude if the problem persists.
            </Text>
            <Link
              appearance="primary-button"
              width="216"
              href="/contact"
              newTab={false}
            >
              Contact Latitude
            </Link>
          </Stack>
        );
      }
    }
  };

  return (
    <Grid rowsGap="6" rowsGap-sm="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard cardName={cardName} cardEndsWith={cardEndsWith} />
      </Container>
      {renderContent()}
    </Grid>
  );
};
